<template lang="pug">
div
  v-list-tile.profile(avatar @click="select" :to="{name:'SettingsProfile'}")
    v-list-tile-avatar.py-4
      img.drawer-avatar(v-if="profile.photo" :src="'data:image/png;base64,' + profile.photo")
      img(v-else src="/static/icons/avatar.png")
    v-list-tile-content.pl-2
      span.grey--text.text--darken-4.subheading {{ profile.firstName }} {{ profile.lastName }}
      span.grey--text.text--darken-1(style="color: #ccc") {{ $tf("drawer.settings.profile") }}
    v-list-tile-action(style="width:34px")
      v-icon chevron_right
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'SettingsDrawer',

  computed: {
    ...mapGetters({
      profile: 'auth/profile',
    }),
  },

  methods: {
    ...mapActions({
      toggleDrawer: 'tools/toggleDrawer',
    }),

    select() {
      if (!this.$vuetify.breakpoint.lgAndUp) {
        this.toggleDrawer()
      }
    },
  },
}
</script>

<style lang="stylus">
  .profile > .v-list__tile
    height auto !important
  .profile-avatar
    border 2px #fff solid
  .ws-n
    white-space normal
  .drawer-avatar
    border 2px #858585 solid
</style>


// WEBPACK FOOTER //
// src/components/settings/SettingsDrawer.vue